import React, { FC } from 'react'
import './service-banner.css'

//COMPONENTS
import * as Icons from '@icons'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    open?: boolean
}

const ServiceBanner: FC<Props> = (props) => {
    const { className: classProp, open = true, ...divProps } = props
    const className = flatten('service-banner', { open }, classProp)

    return (
        <div className={className} {...divProps}>
            <div className="flex flex-row items-center">
                <div className="bubble-sml flex items-center justify-center" style={{ alignSelf: 'center', background: 'var(--splitcard-yellow-300)', flexShrink: 0 }}>
                    <Icons.WarningSmall tint="var(--splitcard-yellow-600)" type='filled' />
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-body'><strong>System Outage</strong></p>
                    <p className='text-body-2'>
                        Mastercard is experiencing a network issue. 
                        Our team is monitoring the situation and functionality will return as soon as the network is restored.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ServiceBanner
